import { useEffect, useState } from "react";
import { useDebounce } from "react-use";

const useDebounceLoading = (loadingArray: boolean[]): boolean => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (loadingArray.some((loading) => !!loading)) {
      setIsLoading(true);
    }
  }, [loadingArray]);

  useDebounce(
    () => {
      if (!loadingArray.some((loading) => !!loading)) {
        setIsLoading(false);
      }
    },
    1500,
    [...loadingArray]
  );

  return isLoading;
};

export default useDebounceLoading;
